import { FaLinkedin } from "react-icons/fa";
import { DiHtml5, DiCss3, DiJavascript1, DiMongodb, DiNodejs, DiReact } from "react-icons/di";

export const HtmlIcon = () => <DiHtml5 />
export const CSSIcon = () => <DiCss3 />
export const JSIcon = () => <DiJavascript1 />
export const MongoDBIcon = () => <DiMongodb />
export const NodeJsIcon = () => <DiNodejs />
export const ReactIcon = () => <DiReact />
export const LinkedInIcon = () => <FaLinkedin />